import React from 'react';
import PropTypes from 'prop-types';
import renderRoutes from 'react-router-config/renderRoutes';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import getRoutesWithStore from '../../react_router/react_router';
import Head from '../components/head/head';
import { TrackerProvider } from '../../utils/tracking/components';
import configuredTracker from '../../utils/tracking/configureTracker';
import { UserProvider } from '../components/context/userContext';
import { ThemeProvider } from 'styled-components';
import theme from '../fc-components/main/themes';

// eslint-disable-next-line
function Root({ store, history, getRoutes, requestUrl }) {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <TrackerProvider tracker={configuredTracker}>
          <ThemeProvider theme={theme}>
            <html lang="en-US">
              <UserProvider>
                <Head />
                {renderRoutes(getRoutesWithStore(store))}
              </UserProvider>
            </html>
          </ThemeProvider>
        </TrackerProvider>
      </ConnectedRouter>
    </Provider>
  );
}

Root.defaultProps = {
  getRoutes: undefined,
  requestUrl: ''
};

Root.propTypes = {
  store: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  getRoutes: PropTypes.func,
  requestUrl: PropTypes.string
};

export default Root;
